export const INSIGHTS_KEYS = {
  ISSUES_NO_GIT_ACTIVITY: 'issues_no_git_activity',
  ISSUES_CARRIED_OVER_SPRINTS: 'issues_carried_over_sprints',
  CONTEXT_SWITCH: 'context_switch',
  ISSUES_WITH_NO_ESTIMATION: 'issues_no_estimation',
  ISSUES_NO_ASSIGNEES: 'issues_no_assignees',
  ISSUES_NO_BRANCHES: 'issues_no_branches',
  ISSUES_IN_STATE: 'issues_in_state'
};

export const INSIGHTS_CATEGORIES = {
  delivery_risk: { key: 'delivery_risk', name: 'Delivery Risk' },
  jira_hygiene: { key: 'jira_hygiene', name: 'PM Best Practices' },
  resource_management: {
    key: 'resource_management',
    name: 'Resource Management'
  }
};
